import {createContext} from 'react';

/**
 * Ids of this course's instructors that own a published instructor community, resolved while the
 * page renders on the server. `undefined` means unknown (not resolved, or the lookup failed), in
 * which case consumers must still query per instructor.
 */
export const CommunityInstructorIdsContext = createContext<string[] | undefined>(undefined);
